import React from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { login, resetAuth } from 'app/shared/reducers/authentication';
import { Card } from 'reactstrap';
import LoginForm from './login-modal';

export const Login = () => {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(state => state.authentication.isAuthenticated);
  const loginError = useAppSelector(state => state.authentication.loginError);

  const navigate = useNavigate();
  const pageLocation = useLocation();

  const handleLogin = (email, password, rememberMe = false) => {
    dispatch(resetAuth());
    dispatch(login(email, password, rememberMe));
  };

  const handleClose = () => {
    navigate('/');
  };

  const { from } = pageLocation.state || { from: { pathname: '/', search: pageLocation.search } };
  if (isAuthenticated) {
    return <Navigate to={from} replace />;
  }
  return (
    <Card className="login-form-card">
      <LoginForm handleLogin={handleLogin} handleClose={handleClose} loginError={loginError} />
    </Card>
  );
};

export default Login;
